export default __webpack_public_path__ + "static/media/슬의.194ae169.jpeg";